<template>
    <div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/share/activity/prize/edit')" type="primary" icon="el-icon-plus" @click="add"
                size="small">创建奖品</el-button>
            <el-button v-if="$utils.have('/shareActivity/joinedUser/createExport')" type="primary"
                @click="download" size="small" :loading="downLoading" icon="el-icon-download">导出获奖用户</el-button>
        </div>
        <div class="page-list-box">
            <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe>
                <el-table-column prop="prizeItem" label="奖项" show-overflow-tooltip></el-table-column>
                <el-table-column prop="prizeInfo" label="奖品" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardNum" label="获奖人数"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/share/activity/prize/info')" type="text" size="small"
                            @click="edit(row.id)">{{ row.awardNum == 0 ? '编辑' : '查看' }}</el-button>
                        <el-button v-if="$utils.have('/share/activity/prize/del') && row.awardNum == 0" type="text"
                            size="small" @click="del(row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
export default {	
    data() {
        return {
            // data: null,
            dataList: null,
            params: {
                shareActivityId: this.$route.query.shareActivityId || "",
            },
            listLoading: true,
            downLoading: false,
			activityEndtime:this.$route.query.time || ''
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/share/activity/prize/list",
                method: "POST",
                params: this.params,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        // this.data = result;
                        this.dataList = result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        add() {
			this.$router.push({path: `/promotion/shareActivity/award/add/${this.params.shareActivityId}`, query: {time:this.activityEndtime}})
        },
        edit(id) {
            this.$router.push({ path: `/promotion/shareActivity/award/edit/${this.params.shareActivityId}/${id}`, query: {time:this.activityEndtime}});
        },
        //删除
        del(id) {
            const _msg = "是否确认删除该奖品?删除后不可恢复";
            this.$confirm(_msg, "提示", {
                type: "warning",
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/share/activity/prize/del",
                    method: "POST",
                    params: { prizeId: id, shareActivityId: this.params.shareActivityId },
                })
                    .then((res) => {
                        const { state, msg } = res.data;
                        if (state == 1) {
                            this.getDataList();
                        } else {
                            this.$message.error(msg || "请求失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("请求错误");
                    })
                    .finally(() => {
                        this.listLoading = false;
                    });
            });
        },
        //导出
        async download() {
            this.downLoading = true;
            this.$request({
                url: '/shareActivity/joinedUser/createExport',
                method: "POST",
                data: {
                    // ...this.params,
                    shareActivityId: parseInt(this.params.shareActivityId),
                    isReward: 1,
                    sort: 1,
                    searchType: 1,
                    pageNo:1,
                    pageSize: 10
                },
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$confirm('下载任务创建成功,可以在下载任务列表查看', '提示', {
                            confirmButtonText: '立即查看',
                            cancelButtonText: '稍后再看',
                            type: 'success',
                            center: true,
                            closeOnClickModal: false
                        }).then(() => {
                            this.$router.push({ path: '/workbench/downloadList' })
                        }).catch(() => { })
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.downLoading = false;
                });
        },
    }
}
</script>